import * as Sentry from '@sentry/react';
import type { CurrentUser } from '@/types/user';

export function trackError(message: string, error?: unknown): void {
  const extra = { message };

  if (typeof Sentry.captureException === 'function') {
    if (error instanceof Error) {
      Sentry.captureException(error, { extra });
    } else if (error === undefined) {
      Sentry.captureException(new Error(message), { extra });
    } else {
      Sentry.captureException(new Error(message), {
        extra: { ...extra, cause: describeUnknown(error) },
      });
    }
  }
}

export function setSentryUser(user: CurrentUser | null | undefined): void {
  if (typeof Sentry.setUser === 'function') {
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.emailAddress,
        username: user.name,
      });
    } else {
      Sentry.setUser(null);
    }
  }
}

function describeUnknown(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  } else {
    return String(error);
  }
}
